import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SosLogService } from '../../../services/sos-log.service';
import { SpinnerService } from '../../../services/spinner.service';
import { NeighborhoodService } from '../../../services/neighborhood.service';

@Component({
  selector: 'app-sos-logs-page',
  templateUrl: './sos-logs-page.component.html',
  styleUrl: './sos-logs-page.component.scss'
})
export class SosLogsPageComponent {

  public neighborhoodId: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    public sosLogService: SosLogService,
    public spinnerService: SpinnerService,
    public neighborhoodService: NeighborhoodService,
  ) {
    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.sosLogService.getAll(this.neighborhoodId!);
      }
    );
  }

}
